import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Col from 'react-bootstrap/lib/Col';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Row from 'react-bootstrap/lib/Row';

import SidePanel from './SidePanel';
import SyncCalendar from './SyncCalendar';
import FooterButton from './FooterButton';
import IncrementButton from '../IncrementButton';
import CommonFormComponent from '../CommonField/CommonFormComponent';

import validateStep3 from './validateStep3';
import updateStep3 from './updateStep3';
import messages from '../../locale/jsonMessages';
import { getDynamicName } from '../../helpers/GetDynamicItemName/getDynamicName';
import { dynamicCancellationValue } from '../../helpers/GetDynamicItemName/dynamicCancellation';

import locationIcon from '/public/SiteIcons/locationIdea.svg';

import cs from '../commonStyle.css';
import s from './ListPlaceStep1.css';

class MinminDays extends Component {

  static propTypes = {
    previousPage: PropTypes.any,
    nextPage: PropTypes.any,
    listId: PropTypes.number.isRequired,
    listingSteps: PropTypes.shape({
      step3: PropTypes.string.isRequired,
      listing: PropTypes.shape({
        isPublished: PropTypes.bool.isRequired
      })
    }),
  };

  static defaultProps = {
    minDayData: 0,
    maxDayData: 0,
    listingSteps: {
      step3: "inactive",
      listing: {
        isPublished: false
      }
    },
  }

  constructor(props) {
    super(props);
    this.state = {
      isDisabled: false,
      minNight: {
        itemName: null,
        otherItemName: null,
        startValue: 0,
        endValue: 0
      },
      maxNight: {
        itemName: null,
        otherItemName: null,
        startValue: 0,
        endValue: 0
      },
      isEqual: false
    };
  }

  UNSAFE_componentWillMount() {
    const { listingFields } = this.props;
    if (listingFields != undefined) {
      this.setState({
        minNight: listingFields?.minNight[0],
        maxNight: listingFields?.maxNight[0],
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { listingFields } = nextProps;
    if (listingFields != undefined) {
      this.setState({
        minNight: listingFields?.minNight[0],
        maxNight: listingFields?.maxNight[0],
      });
    }
  }

  renderIncrementButton = ({ input, label, meta: { error, dirty }, stayNight, labelSingluar, labelPlural }) => {
    const { formatMessage } = this.props.intl;
    const { minDayData, maxDayData } = this.props;
    const { minNight, maxNight } = this.state;
    let disableButton = false;
    if (minDayData > maxDayData) {
      this.setState({
        isDisabled: true
      })
      disableButton = true
    }

    return (
      <div>
        <label className='commonLabelText'>{label}</label>
        <IncrementButton
          {...input}
          labelSingluar={labelSingluar || stayNight?.itemName}
          labelPlural={labelPlural || stayNight?.otherItemName}
          maxValue={stayNight.endValue}
          minValue={stayNight.startValue}
          incrementBy={1}
        />
        {dirty && disableButton && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </div>
    )
  }

  render() {
    const { handleSubmit, previousPage, nextPage, formPage, step } = this.props;
    const { listingSteps, listId, locale, dynamicLanguageData } = this.props;
    const { cancellationPolicies, cancelPolicy } = this.props;
    const { formatMessage } = this.props.intl;
    const { minNight, maxNight } = this.state;
    let dynamicMinNight, dynamicMaxNight;
    dynamicMinNight = getDynamicName({ value: minNight, locale, data: dynamicLanguageData })
    dynamicMaxNight = getDynamicName({ value: maxNight, locale, data: dynamicLanguageData })

    let selectedPolicyContent = '';
    if (cancellationPolicies?.length > 0) {
      const activePolicyId = cancelPolicy ? Number(cancelPolicy) : cancellationPolicies[0]?.id;
      const dynamicPolicy = dynamicCancellationValue(activePolicyId);
      if (dynamicPolicy && dynamicPolicy.content && messages[dynamicPolicy.content]) {
        selectedPolicyContent = formatMessage(messages[dynamicPolicy.content]);
      } else {
        const matchedPolicy = activePolicyId ? cancellationPolicies.find(policy => policy?.id == activePolicyId) : cancellationPolicies[0];
        selectedPolicyContent = matchedPolicy ? matchedPolicy.policyContent : (cancellationPolicies[0]?.policyContent || '');
      }
    }

    return (
      <div className={cx(s.stepGrid, 'stepGridRTL')}>
        <SidePanel
          title={formatMessage(messages.step3Heading)}
          landingContent={formatMessage(messages.availabilityTripText)}
        />
        <form onSubmit={handleSubmit}>
          <div className={cx(s.landingMainContent, s.minMaxMobile)}>
            <div className="oneColumnGrid">
              <Field name="maxDaysNotice" component={CommonFormComponent} inputClass='commonSelectField' labelText={formatMessage(messages.availabilityWindowText)} >
                <option value={"available"}>{formatMessage(messages.datesOption5)}</option>
                <option value={"3months"}>{formatMessage(messages.datesOption1)}</option>
                <option value={"6months"}>{formatMessage(messages.datesOption2)}</option>
                <option value={"9months"}>{formatMessage(messages.datesOption3)}</option>
                <option value={"12months"}>{formatMessage(messages.datesOption4)}</option>
                <option value={"unavailable"}>{formatMessage(messages.datesDropDown)}</option>
              </Field>

              <div className='twoColumnGrid'>
                <Field
                  name="minDay"
                  component={this.renderIncrementButton}
                  stayNight={minNight}
                  labelSingluar={dynamicMinNight?.itemName}
                  labelPlural={dynamicMinNight?.otherItemName}
                  label={formatMessage(messages.minTripLength)}
                />

                <Field
                  name="maxDay"
                  component={this.renderIncrementButton}
                  stayNight={maxNight}
                  labelSingluar={dynamicMaxNight?.itemName}
                  labelPlural={dynamicMaxNight?.otherItemName}
                  label={formatMessage(messages.maxTripLength)}
                />
              </div>

              <Field name="cancellationPolicy"
                component={CommonFormComponent}
                inputClass='commonSelectField'
                labelText={formatMessage(messages.chooseCancellationPolicy)}
                note={
                  <div>
                    <img src={locationIcon} className={cx(cs.positionRelative, cs.topMinus3)} />&nbsp;
                    <span className={cx(s.locationTipCss, cs.commonMediumText)}>{selectedPolicyContent}</span>
                  </div>
                }
              >
                <option value={"1"}>{formatMessage(messages.flexible)}</option>
                <option value={"2"}>{formatMessage(messages.moderate)}</option>
                <option value={"3"}>{formatMessage(messages.strict)}</option>
              </Field>

              {
                listingSteps?.step3 === "completed" && listingSteps.listing && listingSteps.listing.isPublished &&
                <div>
                  <label className='commonLabelText'><FormattedMessage {...messages.syncCalendars} /></label>
                  <SyncCalendar listId={listId} />
                </div>
              }
            </div>
          </div>
          <FooterButton
            nextPage={nextPage}
            previousPage={previousPage}
            nextPagePath={"calendar"}
            previousPagePath={"discount"}
            formPage={formPage}
            step={step}
          />
        </form>
      </div>
    );
  }
}

// Decorate with connect to read form values
const selector = formValueSelector('ListPlaceStep3'); // <-- same as form name

MinminDays = reduxForm({
  form: 'ListPlaceStep3', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateStep3,
  onSubmit: updateStep3
})(MinminDays);

const mapState = (state) => ({
  minDayData: selector(state, 'minDay'),
  maxDayData: selector(state, 'maxDay'),
  cancelPolicy: selector(state, 'cancellationPolicy'),
  listingFields: state?.listingFields?.data,
  listingSteps: state?.location?.listingSteps,
  cancellationPolicies: state?.location?.cancellationPolicies,
  locale: state?.intl?.locale,
  dynamicLanguageData: state?.dynamicListSettings?.data
});

const mapDispatch = {
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(MinminDays)));
